// Connects PostHog to the app's own state: starts it once /api/me says how, identifies the
// signed-in host, records a session only for them and off the auth pages, resets on sign-out (from any of the sign-out buttons), and keeps the UTM tags
// of the link the visitor arrived on. Renders nothing.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import {
  identifyUser,
  rememberAttribution,
  resetAnalytics,
  startAnalytics,
  syncRecording,
} from '@/lib/analytics';
import { useMe } from '@/lib/queries';

export function AnalyticsBridge() {
  const me = useMe();
  const { pathname, search } = useLocation();
  const config = me.data?.analytics ?? null;
  const user = me.data?.user ?? null;
  const userId = user?.id ?? null;
  const email = user?.email ?? null;
  const identified = useRef<string | null>(null);

  useEffect(() => {
    rememberAttribution(search);
  }, [search]);

  useEffect(() => {
    if (config) void startAnalytics(config);
  }, [config]);

  useEffect(() => {
    if (!me.data) return;
    if (userId && email && identified.current !== userId) {
      identifyUser({ id: userId, email });
      identified.current = userId;
    } else if (!userId && identified.current) {
      resetAnalytics();
      identified.current = null;
    }
  }, [me.data, userId, email]);

  // Replay only after the identify above, and never on an auth, reset or invite page.
  useEffect(() => {
    if (!me.data) return;
    syncRecording(pathname, !!userId);
  }, [me.data, pathname, userId]);

  return null;
}
